import { CSSProperties } from "react";
import { CatalogCard, HandCard } from "src/api";

import { useGame } from "../../game/GameContext";
import { useSessionView } from "../../game/useSessionView";
import { useDevState } from "../dev/DevMenu";
import "./Cards.css";

type CardProps = {
  card: CatalogCard | HandCard;
  rotate?: string;
};

export function Card({ card, rotate }: CardProps) {
  return (
    <div
      className="card-ui"
      data-rarity={card.rarity}
      data-picking={"picking" in card && card.picking}
      title={card.text}
      style={{ "--angle": rotate } as CSSProperties}
    >
      <div className="card-rarity-line"></div>
      <div className="card-art" />
      <div className="card-gear" />
      <div className="card-name">{card.name}</div>
      <div className="card-desc">{card.short}</div>
    </div>
  );
}

export function CardHolder() {
  const { session } = useGame();
  const cards = useSessionView()?.hand?.cards;
  const { cardDisplayOverrideEnabled, cardDisplayData } = useDevState();
  const hand = cardDisplayOverrideEnabled ? (cardDisplayData ?? []) : cards;

  if (!hand) return null;

  const fanDegrees = 70 / (hand.length - 1);
  return (
    <div className="card-fan" style={{ "--step": `${fanDegrees}deg` } as CSSProperties}>
      {hand.map((card, i) => (
        <Card
          key={i}
          card={card}
          rotate={`${(i - (hand.length - 1) / 2) * fanDegrees}deg`}
        />
      ))}
    </div>
  );
}
